import logger from '../utils/logger';
import React, { useState, useEffect, useContext } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import PageTopBar from './customComponents/PageTopBar';
import { Home, FileText, FlaskConical, FileCheck } from 'lucide-react';
import '../style/Radiology.css';
import UserDetails from './customComponents/tracker';
import { formatTo12Hour, formatAppointmentDate, formatAppointmentTimeRange, capitalize, convertUTCToLocal, convertUTCToCentral, formatDateOfBirth, dateOfBirth, numberedList, sanitizeDateForInput, getUserId, formatTimePlusFiveHours} from '../utils/utils';
import { GlobalStateContext } from '../utils/GlobalStateContext';
import RISFollowUpNotesModal from './customComponents/RISFollowUpNotesModal';

//import { report } from '../../../backend/routes/routes';

// Hardcoded data for initial schedule
// const scheduleData = {
//   today: [
//     { id: 1, patient_name: 'John Doe', modality:'CT', description: 'Chest', time: '2025-04-17 09:00', examId: 101 },
//     { id: 2, patient_name: 'Jane Smith', modality:'MRI', description:'Brain', time: '2025-04-17 10:30', examId: 102 },
//     { id: 3, patient_name: 'Alice Brown', modality:'US', description:'Abdomen', time: '2025-04-17 13:00', examId: 103 },
//   ],
//   week: [
//     { id: 4, patient_name: 'Bob Johnson', modality:'DR', description: 'Spine', time: '2025-04-18 11:00', examId: 104 },
//     { id: 5, patient_name: 'Emma Wilson', modality:'CT', description: 'Head', time: '2025-04-19 14:00', examId: 105 },
// ],
//   month: [
//     { id: 6, patient_name: 'Liam Davis', modality:'MRI', description: 'Knee', time: '2025-04-18 11:00', examId: 106 },
//     { id: 7, patient_name: 'Olivia Lee', modality:'US', description: 'Thyroid', time: '2025-04-19 14:00', examId: 107 },
//   ],
// };
// // Hardcoded data for exam status
// const examStatusData = [
//   { id: 101, patient_name: 'John Doe', modality: 'CT', description: 'Chest', status: 'Scheduled' },
//   { id: 102, patient_name: 'Jane Smith', modality: 'MRI', description: 'Brain', status: 'Arrived' },
//   { id: 103, patient_name: 'Alice Brown', modality: 'US', description: 'Abdomen', status: 'Scanned' },
//   { id: 104, patient_name: 'Bob Johnson', modality: 'DR', description: 'Spine', status: 'Transmitting' },
//   { id: 105, patient_name: 'Emma Wilson', modality: 'CT', description: 'Head', status: 'Received' },
//   { id: 106, patient_name: 'Liam Davis', modality: 'MRI', description: 'Knee', status: 'Complete' },
//   { id: 107, patient_name: 'Olivia Lee', modality: 'US', description: 'Thyroid', status: 'Scheduled' },
// ];
// // Hardcoded data for exam details
// const examDetailsData = {
//   101: {
//     id: 101,
//     patientId: 1001,
//     modality: 'CT',
//     description: 'Chest CT with iodinated contrast for pulmonary evaluation',
//     priority: 'Routine',
//     numberOfImages: 8,
//     status: 'Scheduled',
//     priorReports: "Yes", 
//     priorExams: "Yes",
//     studyDate: '2025-04-28',
//     facility: 'Facility A',
//     billableHistory: 'Yes',
//   },
//   102: {
//     id: 102,
//     patientId: 1002,
//     modality: 'MRI',
//     description: 'Brain MRI to assess neurological symptoms',
//     priority: 'STAT',
//     numberOfImages: 17,
//     status: 'Arrived',
//     priorReports: "Yes", 
//     priorExams: "Yes",
//     studyDate: '2025-04-28',
//     facility: 'Facility A',
//     billableHistory: 'Yes',
//   },
//   103: {
//     id: 103,
//     patientId: 1003,
//     modality: 'US',
//     description: 'Abdominal ultrasound for liver assessment',
//     priority: 'Routine',
//     numberOfImages: 10,
//     status: 'Scanned',
//     priorReports: "Yes", 
//     priorExams: "Yes",
//     studyDate: '2025-04-28',
//     facility: 'Facility A',
//     billableHistory: 'Yes',
//   },
//   104: {
//     id: 104,
//     patientId: 1004,
//     modality: 'DR',
//     description: 'Spinal digital radiography for scoliosis evaluation',
//     priority: 'Next Day',
//     numberOfImages: 5,
//     status: 'Transmitting',
//     priorReports: "Yes", 
//     priorExams: "Yes",
//     studyDate: '2025-04-28',
//     facility: 'Facility A',
//     billableHistory: 'Yes',
//   },
//   105: {
//     id: 105,
//     patientId: 1005,
//     modality: 'CT',
//     description: 'Head CT for trauma assessment',
//     priority: 'Trauma',
//     numberOfImages: 8,
//     status: 'Received',
//     priorReports: "Yes", 
//     priorExams: "Yes",
//     studyDate: '2025-04-28',
//     facility: 'Facility A',
//     billableHistory: 'Yes',
//   },
//   106: {
//     id: 106,
//     patientId: 1006,
//     modality: 'MRI',
//     description: 'Knee MRI for ligament injury',
//     priority: '2 days',
//     numberOfImages: 12,
//     status: 'Complete',
//     priorReports: "Yes", 
//     priorExams: "Yes",
//     studyDate: '2025-04-28',
//     facility: 'Facility A',
//     billableHistory: 'Yes',
//   },
//   107: {
//     id: 107,
//     patientId: 1007,
//     modality: 'US',
//     description: 'Thyroid ultrasound for nodule evaluation',
//     priority: 'Routine',
//     numberOfImages: 10,
//     status: 'Scheduled',
//     priorReports: "No", 
//     priorExams: "Yes",
//     studyDate: '2025-04-28',
//     facility: 'Facility A',
//     billableHistory: 'Yes',
//   },
// };
// Hardcoded data for prior reports and images
const priorReportsData = {
  1001: [
    { id: 301, date: '2024-01-16', modality: 'CT', description: 'Chest', status: 'Completed' },
    { id: 302, date: '2023-06-21', modality: 'DR', description: 'Chest', status: 'Completed' },
  ],
  1002: [
    { id: 303, date: '2024-02-10', modality: 'MRI', description: 'Brain', status: 'Completed' },
  ],
  1003: [
    { id: 304, date: '2023-12-05', modality: 'US', description: 'Abdominal', status: 'Completed' },
  ],
  1004: [],
  1005: [
    { id: 305, date: '2024-03-15', modality: 'CT', description: 'Head', status: 'Completed' },
  ],
  1006: [
    { id: 306, date: '2023-11-20', modality: 'MRI', description: 'Knee', status: 'Completed' },
  ],
  1007: [],
};

const priorImagesData = {
  1001: [
    { id: 201, date: '2024-01-15', modality: 'CT', description: 'Previous Chest CT', isPrior: true },
    { id: 202, date: '2023-06-20', modality: 'DR', description: 'Chest X-Ray', isPrior: true },
  ],
  1002: [
    { id: 203, date: '2024-02-09', modality: 'MRI', description: 'Previous Brain MRI', isPrior: true },
  ],
  1003: [
    { id: 204, date: '2023-12-04', modality: 'US', description: 'Previous Abdominal US', isPrior: true },
  ],
  1004: [],
  1005: [
    { id: 205, date: '2024-03-14', modality: 'CT', description: 'Previous Head CT', isPrior: true },
  ],
  1006: [
    { id: 206, date: '2023-11-19', modality: 'MRI', description: 'Previous Knee MRI', isPrior: true },
  ],
  1007: [],
};

//dropdown list of options to select from for priority and status
const priorities = ['Routine', 'STAT', 'Stroke', 'Trauma', 'Next Day', '2 Day'];
const statuses = ['scheduled', 'arrived', 'scanned', 'transmitting', 'received', 'complete', 'cancelled'];


// Adding Rad Patient Checklist Component
const RadPatientChecklist = ({id}) => {
    // const [radiologyOrders, setRadiologyOrders] = useState([]);
    const [isEditing, setIsEditing] = useState(false);
    const [iodineContrast, setIodineContrast] = useState(false);
    // const [iodineReordered, setIodineReordered] = useState(false);
    // const [gadReordered, setGadReordered] = useState(false);
    const [gadContrast, setGadContrast] = useState(false);
    const BASE_URL = process.env.REACT_APP_API_URL;
    // const [contrastData, setContrastData] = useState([]);
    const { currentUser} = useContext(GlobalStateContext);
    // logger.log('current user: ', currentUser)
    const user = getUserId(currentUser);

    const [iodineData, setIodineData] = useState({
      name: '',
      type: 'Iodine',
      volume: '',
      lot_number: '',
      discard_amount: '',
      reordered: false
    });
    const [gadData, setGadData] = useState({
      name: '',
      type: 'Gadolinium',
      volume: '',
      lot_number: '',
      discard_amount: '',
      reordered: false
    });
    const [checklistData, setChecklistData] = useState([
        {
            order_received: true,
            authorization_received: false,
            name_confirmed: false,
            height: null,
            weight: null,
            radiation_dose: null,
            labs_reviewed: false,
            contrast_allergy: false,
            pregnancy_check: false,
            contrast_reviewed: false,
            metal_reviewed: false,
            consent_reviewed: false,
            contrast_reaction: false,
            contrast_reaction_notes: '',
            pregnancy_status: false,
            lmp: ''
        },
    ]);

    const [originalIodineData, setOriginalIodineData] = useState(iodineData);
    const [originalGadData, setOriginalGadData] = useState(gadData);

    // const handleChecklistChange = (rowIndex, field, value) => {
    //     const newData = [...checklistData];
    //     newData[rowIndex][field] = value;
    //     setChecklistData(newData);
    // };

    const handleChecklistChange = (field, value) => {
      const newData = [...checklistData];
      newData[0][field] = value;
      setChecklistData(newData);
    };

    const handleIodineChange = (field, value) => {
        const newData = {...iodineData};
        newData[field] = value;
        setIodineData(newData);
    };
    const handleGadChange = (field, value) => {
        const newData = {...gadData};
        newData[field] = value;
        setGadData(newData);
    };

    //get checklist information
    useEffect(() => {
      const fetchChecklist = async () => {
        try {
            const response = await fetch(`${BASE_URL}/orders/radChecklist?id=${id}&user=${user}&type=${currentUser.type}`);
            if (response.ok) {
            const data = await response.json();
            // logger.log('data: ', data)
            // logger.log("Radiology checklist: " + JSON.stringify(data));
            const formattedChecklist = [...data]; // Create a copy of the array
            // logger.log('formatted checklist data: ', formattedChecklist)
            if (formattedChecklist.length) formattedChecklist[0].lmp = sanitizeDateForInput(data[0]?.lmp);
            setChecklistData(formattedChecklist);
            }
            
        } catch (error) {
            logger.error("Error fetching radiology orders", error);
        }
      }
        const fetchContrast = async () => {
          try {
            const response = await fetch(`${BASE_URL}/orders/contrastInfo?rad_orders_id=${id}&user=${user}&type=${currentUser.type}`);
            if (response.ok) {
              const data = await response.json();

              if (data.length > 0) {
                if (data[0].type === "Iodine") {
                  setIodineContrast(true);
                  // setIodineReordered(data[0].reordered);
                  setIodineData(data[0]);
                  if (data.length > 1) {
                    setGadContrast(true);
                    // setGadReordered(data[1].reordered);
                    setGadData(data[1]);
                  }
                } else {
                  setGadContrast(true);
                  // setGadReordered(data[0].reordered);
                  setGadData(data[0]);
                  if (data.length > 1) {
                    setIodineContrast(true);
                    // setIodineReordered(data[1].reordered);
                    setIodineData(data[1]);
                  }
                }
              }
            }
          } catch (error) {
            logger.error("Error fetching radiology orders", error);
          }
        };

      fetchChecklist();
      fetchContrast();
    }, [id])

    //save checklist information
const saveChecklist = async (checklistData) => {
  if (isEditing) {
    try {
      const response = await fetch(`${BASE_URL}/orders/radChecklist`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ checklistData: checklistData[0], id, user, type: currentUser.type}),
      });
      if (response.ok) {
        const data = await response.json();
        // logger.log("Radiology checklist: " + JSON.stringify(data));
        // Optionally update state here
      }
    } catch (error) {
      logger.error("Error updating radiology checklist", error);
    }
  }

  setIsEditing(!isEditing); // Toggle after save
};

const saveContrast = async () => {
  // Save iodine if applicable
  if (iodineContrast) {
    if (iodineData.rad_orders_id) {
      await iodinePatch();  // Update
    } else {
      await iodinePost();   // Insert
    }
  }

  // Save gadolinium if applicable
  if (gadContrast) {
    if (gadData.rad_orders_id) {
      await gadPatch();  // Update
    } else {
      await gadPost();   // Insert
    }
  }
};


const iodinePost = async () => {
  if(iodineContrast){
  try {
    const response = await fetch(`${BASE_URL}/orders/contrastInfo`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ data: iodineData, rad_orders_id: id, user, type: currentUser.type}),
    });
    if (response.ok) {
      logger.log("Contrast data saved");
    }
  } catch (error) {
    logger.error("Error saving contrast data", error);
  }
}};
const gadPost = async () => {
  if(gadContrast){
  try {
    const response = await fetch(`${BASE_URL}/orders/contrastInfo`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ data: gadData, rad_orders_id: id, user, type: currentUser.type }),
    });
    if (response.ok) {
      logger.log("Contrast data saved");
    }
  } catch (error) {
    logger.error("Error saving contrast data", error);
  }
}
};

const iodinePatch = async () => {
  if (iodineContrast) {
    const fieldsToUpdate = getChangedFields(iodineData, originalIodineData);
    if (Object.keys(fieldsToUpdate).length === 0) return;

      // logger.log(id)
      // logger.log(fieldsToUpdate)

    try {
      const response = await fetch(`${BASE_URL}/orders/contrastInfo`, {
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          rad_orders_id: id,
          fieldsToUpdate,
          type: iodineData.type,
          user, 
          userType: currentUser.type
        }),
      });
      if (response.ok) {
        logger.log("Iodine contrast updated");
      }
    } catch (error) {
      logger.error("Error updating iodine contrast", error);
    }
  }
};

const gadPatch = async () => {
  if (gadContrast) {
    const fieldsToUpdate = getChangedFields(gadData, originalGadData);
    if (Object.keys(fieldsToUpdate).length === 0) return;
    try {
      const response = await fetch(`${BASE_URL}/orders/contrastInfo`, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          rad_orders_id: id,
          fieldsToUpdate,
          type: gadData.type,
          user, 
          type: currentUser.type
        }),
      });
      if (response.ok) {
        logger.log("Gadolinium contrast updated");
      }
    } catch (error) {
      logger.error("Error updating gadolinium contrast", error);
    }
  }
};

/*    if (key === 'pregnancy_status' && newData[key] === false) {
      changed.lmp = null;
    }

    if (key === 'contrast_reaction' && newData[key] === false) {
      changed.contrast_reaction_notes = null;
    }
      */

  const priorChecks = () => {
    const updatedChecklist = [...checklistData];

    if (!updatedChecklist.length) return;

    if (
      !!updatedChecklist[0].contrast_reaction === false &&
      updatedChecklist[0].contrast_reaction_notes !== null
    ) {
      updatedChecklist[0].contrast_reaction_notes = null;
    }

    if (
      !!updatedChecklist[0].pregnancy_status === false &&
      updatedChecklist[0].lmp !== null
    ) {
      updatedChecklist[0].lmp = null;
    }

    setChecklistData(updatedChecklist);
  };

  const handleEditToggle = async () => {
    if (isEditing) {
      try {
        priorChecks();
        await saveChecklist(checklistData);
        await saveContrast();
      } finally {
        setIsEditing(false);
      }
    } else {
      // entering edit mode — snapshot original state
      setOriginalIodineData(iodineData);
      setOriginalGadData(gadData);
      setIsEditing(true);
    }
  };

const getChangedFields = (newData, originalData) => {
  const changed = {};
  for (const key in newData) {
    if (newData[key] !== originalData[key]) {
      changed[key] = newData[key];
    }
  }

  return changed;
};

    return (
        <div>
          <div className='radiology-row'>
            <h3 className="checklist-titles">Patient Checklist</h3>
            <button onClick={handleEditToggle} className="ris-little-blue-button">
                {isEditing ? 'Done' : 'Edit'}
            </button>
            </div>
            <div key={checklistData[0]?.id} className="ris-radiology-checklist-grid">
              <div className="ris-checklist-row">
                <label>Order Received</label>
                <p>{isEditing ? <input type="checkbox" className='checkbox-size' checked={checklistData[0]?.order_received} onChange={(e) => handleChecklistChange('order_received', e.target.checked)} /> : (checklistData[0]?.order_received ? '✓' : '—')}</p>
              </div>
              <div className="ris-checklist-row">
                <label>Authorization Received</label>
                <p>{isEditing ? <input type="checkbox" className='checkbox-size' checked={checklistData[0]?.authorization_received} onChange={(e) => handleChecklistChange('authorization_received', e.target.checked)} /> : (checklistData[0]?.authorization_received ? '✓' : '—')}</p>
              </div>
              <div className="ris-checklist-row">
                <label>Patient Name Confirmed</label>
                <p>{isEditing ? <input type="checkbox" className='checkbox-size' checked={checklistData[0]?.name_confirmed} onChange={(e) => handleChecklistChange('name_confirmed', e.target.checked)} /> : (checklistData[0]?.name_confirmed ? '✓' : '—')}</p>
              </div>
              <div className="ris-checklist-row">
                <label>Patient Height (in.)</label>
                <p>{isEditing ? <input type="text" className='' value={checklistData[0]?.height} onChange={(e) => handleChecklistChange('height', e.target.value)} /> : (checklistData[0]?.height ? '✓' : '—')}</p>
              </div>
              <div className="ris-checklist-row">
                <label>Patient Weight (lbs.)</label>
                <p>{isEditing ? <input type="text" className='' value={checklistData[0]?.weight} onChange={(e) => handleChecklistChange('weight', e.target.value)} /> : (checklistData[0]?.weight ? '✓' : '—')}</p>
              </div>
              <div className="ris-checklist-row">
                <label>Radiation Dose (mSv)</label>
                <p>{isEditing ? <input type="text" className='' value={checklistData[0]?.radiation_dose ?? ''} onChange={(e) => handleChecklistChange('radiation_dose', e.target.value)} /> : (checklistData[0]?.radiation_dose || '—')}</p>
              </div>
              <div className="ris-checklist-row">
                <label>Labs Reviewed</label>
                <p>{isEditing ? <input type="checkbox" className='checkbox-size' checked={checklistData[0]?.labs_reviewed} onChange={(e) => handleChecklistChange('labs_reviewed', e.target.checked)} /> : (checklistData[0]?.labs_reviewed ? '✓' : '—')}</p>
              </div>
              <div className="ris-checklist-row">
                <label>Pregnancy Check</label>
                <p>{isEditing ? <input type="checkbox" className='checkbox-size' checked={checklistData[0]?.pregnancy_check} onChange={(e) => handleChecklistChange('pregnancy_check', e.target.checked)} /> : (checklistData[0]?.pregnancy_check ? '✓' : '—')}</p>
              </div>

{isEditing && checklistData[0]?.pregnancy_check ? (
  <div className="ris-checklist-row">
    <label>Is the patient possibly pregnant?</label>
    <div className="ris-checklist-dual-checkboxes">
      <label>
        <input
          type="checkbox"
          className='checkbox-size'
          checked={!!checklistData[0]?.pregnancy_status === true}
          onChange={() => handleChecklistChange('pregnancy_status', true)}
        />
        Yes
      </label>
      <label>
        <input
          type="checkbox"
          className='checkbox-size'
          checked={!!checklistData[0]?.pregnancy_status === false}
          onChange={() => handleChecklistChange('pregnancy_status', false)}
        />
        No
      </label>
    </div>
  </div>
) : (
  <div className="ris-checklist-row">
    <p>
      {!!checklistData[0]?.pregnancy_status === true
        ? '✓ Possibly Pregnant'
        : !!checklistData[0]?.pregnancy_status === false
        ? 'Likely not Pregnant'
        : '—'}
    </p>
  </div>
)}

{!!checklistData[0]?.pregnancy_status === true && isEditing && (
  <div className="ris-checklist-notes">
    <label htmlFor="lmp">Last Menstrual Period (LMP)</label>
    <input
      type="date"
      id="lmp"
      className='lmp-date-selector'
      value={sanitizeDateForInput(checklistData[0]?.lmp) || ''}
      onChange={(e) =>
        handleChecklistChange('lmp', e.target.value)
      }
    />
  </div>
)}
              <div className="ris-checklist-row">
                <label>Metal Reviewed</label>
                <p>{isEditing ? <input type="checkbox" className='checkbox-size' checked={checklistData[0]?.metal_reviewed} onChange={(e) => handleChecklistChange('metal_reviewed', e.target.checked)} /> : (checklistData[0]?.metal_reviewed ? '✓' : '—')}</p>
              </div>
              <div className="ris-checklist-row">
                <label>Consent Reviewed</label>
                <p>{isEditing ? <input type="checkbox" className='checkbox-size' checked={checklistData[0]?.consent_reviewed} onChange={(e) => handleChecklistChange('consent_reviewed', e.target.checked)} /> : (checklistData[0]?.consent_reviewed ? '✓' : '—')}</p>
              </div>
            </div>
            <h3 className="checklist-titles">Contrast Checklist</h3>
            <div className='radiology-contrast-container'>
              {/* <h4 style={{marginLeft:"10px"}}>Contrast Checklist</h4> */}
                <div className="ris-checklist-row">
                  <label>Contrast Allergy</label>
                    <p>{isEditing ? <input type="checkbox" className='checkbox-size' checked={checklistData[0]?.contrast_allergy} onChange={(e) => handleChecklistChange('contrast_allergy', e.target.checked)} /> : (checklistData[0]?.contrast_allergy ? '✓' : '—')}</p>
                </div>
                <div className="ris-checklist-row">
                  <label>Contrast Protocol Reviewed</label>
                  <p>{isEditing ? <input type="checkbox" className='checkbox-size' checked={checklistData[0]?.contrast_reviewed} onChange={(e) => handleChecklistChange('contrast_reviewed', e.target.checked)} /> : (checklistData[0]?.contrast_reviewed ? '✓' : '—')}</p>
                </div>
<div className="ris-checklist-row">
  <label>Any Previous Contrast Reactions?</label>

  {isEditing ? (
    <div className="ris-checklist-dual-checkboxes">
      <label>
        <input
          type="checkbox"
          className='checkbox-size'
          checked={!!checklistData[0]?.contrast_reaction === true}
          onChange={() => handleChecklistChange('contrast_reaction', true)}
        />
        Yes
      </label>
      <label>
        <input
          className='checkbox-size'
          type="checkbox"
          checked={!!checklistData[0]?.contrast_reaction === false}
          onChange={() => handleChecklistChange('contrast_reaction', false)}
        />
        No
      </label>
    </div>
  ) : (
    <p>
      {!!checklistData[0]?.contrast_reaction === true
        ? 'Yes'
        : !!checklistData[0]?.contrast_reaction === false
        ? 'No'
        : '—'}
    </p>
  )}
</div>

{!!checklistData[0]?.contrast_reaction === true && 
 isEditing ? (
  <div className="ris-checklist-notes">
    <label htmlFor="reaction-notes">Reaction Details</label>
    <textarea
      id="reaction-notes"
      value={checklistData[0]?.contrast_reaction_notes || ''}
      onChange={(e) => handleChecklistChange('contrast_reaction_notes', e.target.value)}
      placeholder="Describe the patient's previous reaction..."
    />
  </div> ) : <div className="ris-checklist-notes">
    <label htmlFor="reaction-notes">Reaction Details</label>
    <span id="reaction-notes"> {checklistData[0]?.contrast_reaction_notes || ''} </span>
  </div>
}
            {!checklistData[0]?.contrast_reaction && !checklistData[0]?.contrast_allergy && (<>
              <div className='radiology-contrast-info'>
                <h4>
                  Iodine Contrast 
                  {isEditing ? (
                    <input type="checkbox" className='checkbox-size' checked={iodineContrast}  onChange={(e) => setIodineContrast(e.target.checked)} />
                  ) : (iodineContrast ? ' Yes' : ' No')}
                </h4>
                <h4>
                  Gadolinium Contrast
                  {isEditing ? (
                    <input type="checkbox" checked={gadContrast} className='checkbox-size' onChange={(e) => setGadContrast(e.target.checked)} />
                  ) : (gadContrast ? ' Yes' : ' No')}
                </h4>
              </div>

                <div className={iodineContrast ? 'radiology-contrast-content' : 'radiology-nope'}>
                  <p>Iodine Contrast Name:</p>
                  {isEditing ? <input type='text'  value={iodineData.name}  onChange={(e) => handleIodineChange('name', e.target.value)} /> : <p>{iodineData.name}</p>}
                  <p>Iodine Contrast Volume:</p>
                  {isEditing ? <input type='text'  value={iodineData.volume}  onChange={(e) => handleIodineChange('volume', e.target.value)} /> : <p>{iodineData.volume}</p>}
                  <p>Iodine Contrast Lot #:</p>
                  {isEditing ? <input type='text'  value={iodineData.lot_number}  onChange={(e) => handleIodineChange('lot_number', e.target.value)} /> : <p>{iodineData.lot_number}</p>}
                  <p>Iodine Discard Amount:</p>
                  {isEditing ? <input type='text'  value={iodineData.discard_amount}  onChange={(e) => handleIodineChange('discard_amount', e.target.value)} /> : <p>{iodineData.discard_amount}</p>}
                  <div className='radiology-contrast-reorder'>
                    <p>
                      Iodine Reordered: 
                      {isEditing ? (
                        <input type="checkbox" checked={iodineData.reordered} className='checkbox-size' onChange={(e) => handleIodineChange('reordered', e.target.checked)} />
                      ) : (iodineData.reordered ? ' Yes' : ' No')}
                    </p>
                  </div>
                </div>

                <div className={gadContrast ? 'radiology-contrast-content' : 'radiology-nope'}>
                  <p>Gadolinium Name:</p>
                  {isEditing ? <input type='text' value={gadData.name} onChange={(e) => handleGadChange('name', e.target.value)} /> : <p>{gadData.name}</p>}
                  <p>Gadolinium Volume:</p>
                  {isEditing ? <input type='text' value={gadData.volume} onChange={(e) => handleGadChange('volume', e.target.value)} /> : <p>{gadData.volume}</p>}
                  <p>Gadolinium Lot #:</p>
                  {isEditing ? <input type='text' value={gadData.lot_number} onChange={(e) => handleGadChange('lot_number', e.target.value)} /> : <p>{gadData.lot_number}</p>}
                  <p>Gadolinium Discard Amount:</p>
                  {isEditing ? <input type='text' value={gadData.discard_amount} onChange={(e) => handleGadChange('discard_amount', e.target.value)} /> : <p>{gadData.discard_amount}</p>}
                  <div className='radiology-contrast-reorder'>
                    <p>
                      Gadolinium Reordered: 
                      {isEditing ? (
                        <input type="checkbox" checked={gadData.reordered} className='checkbox-size' onChange={(e) => handleGadChange('reordered', e.target.checked)} />
                      ) : (gadData.reordered ? ' Yes' : ' No')}
                    </p>
                  </div>
                </div>
            </>)}
            </div>
        </div>
    );
};


//main component for Radiology
// This component will be the main page for the Radiology section of the application
const Radiology = () => {
  const [activeTab, setActiveTab] = useState('schedule');
  const [selectedExamId, setSelectedExamId] = useState(null);
  const [notesModalOpen, setNotesModalOpen] = useState(false);
  const { currentUser } = useContext(GlobalStateContext);
  const navigate = useNavigate();

  const canWriteNote = currentUser?.type === 'clinician' || currentUser?.type === 'admin';

  const topBarLinks = [
    { label: 'Home', to: '/home', icon: Home },
    { label: 'Orders', to: '/orders', icon: FileText },
    { label: 'Labs', to: '/labs', icon: FlaskConical },
    { label: 'Results', to: '/results', icon: FileCheck },
    ...(canWriteNote ? [
      {
        label: 'Follow-Up Note',
        icon: FileText,
        onClick: () => navigate(selectedExamId ? `/risFollowUpNote?exam_id=${selectedExamId}` : '/risFollowUpNote'),
      },
      {
        label: 'View Notes',
        icon: FileCheck,
        onClick: () => setNotesModalOpen(true),
      },
    ] : []),
  ];

  return (
    <div className="radiology-page">
      <PageTopBar links={topBarLinks} />
      <RISFollowUpNotesModal isOpen={notesModalOpen} onClose={() => setNotesModalOpen(false)} />
      <div className="radiology-content">
      <div className="ris-lab-header">
        <h2>Radiology Section</h2>
      </div>
      {!selectedExamId ? (
        <>
          <div className="ris-radiology-tabs">
            <button
              className={activeTab === 'schedule' ? 'active' : ''}
              onClick={() => setActiveTab('schedule')}
            >
              Schedule
            </button>
            <button
              className={activeTab === 'examStatus' ? 'active' : ''}
              onClick={() => setActiveTab('examStatus')}
            >
              Exam Status
            </button>
          </div>
          {activeTab === 'schedule' && <Schedule onSelectExam={setSelectedExamId} />} 
          {activeTab === 'examStatus' && <ExamStatus onSelectExam={setSelectedExamId} />}
        </>
      ) : (
        <ExamDetail examId={selectedExamId} onBack={() => setSelectedExamId(null)} />
      )}
      </div>
    </div>
  );
};

const Schedule = ({ onSelectExam }) => {
  const [view, setView] = useState('today');
  const [currentSchedule, setCurrentSchedule] = useState([]);
  const {currentPatient, setCurrentPatient} = useContext(GlobalStateContext);
  const {currentUser} = useContext(GlobalStateContext);
  // const currentSchedule = scheduleData[view] || [];
  const BASE_URL = process.env.REACT_APP_API_URL;
  const user = getUserId(currentUser);


  useEffect(() => {
    const fetchcurrentSchedule = async () => {
      try {
            const response = await fetch(`${BASE_URL}/orders/radTodayCurrentSchedule?user=${user}&type=${currentUser.type}`);
            if (response.ok) {
            const data = await response.json();
            setCurrentSchedule(data);
            }
        } catch (error) {
            logger.error("Error fetching today's radiology orders", error);
        }
    }

    fetchcurrentSchedule();
  }, [])

  const handleSchedule = async (range) => {
    switch(range) {
      case "today":
        setCurrentSchedule([]);
         try {
            const response = await fetch(`${BASE_URL}/orders/radTodayCurrentSchedule?user=${user}&type=${currentUser.type}`);
            if (response.ok) {
            const data = await response.json();
            if (data.length > 0) {
              setCurrentSchedule(data);
            }
            }
        } catch (error) {
            logger.error("Error fetching today's radiology orders", error);
        }
        break;
      case "week":
        setCurrentSchedule([]);
        try {
            const response = await fetch(`${BASE_URL}/orders/radWeekCurrentSchedule?user=${user}&type=${currentUser.type}`);
            if (response.ok) {
            const data = await response.json();
            setCurrentSchedule(data);
            }
        } catch (error) {
            logger.error("Error fetching this week's radiology orders", error);
        }
        break;
      case "month":
        setCurrentSchedule([]);
        try {
            const response = await fetch(`${BASE_URL}/orders/radMonthCurrentSchedule?user=${user}&type=${currentUser.type}`);
            if (response.ok) {
            const data = await response.json();
            setCurrentSchedule(data);
            }
        } catch (error) {
            logger.error("Error fetching this month's radiology orders", error);
        }
        break;
      default:
        logger.log("No matching case")
    }
  }

  return (
    <div className="ris-radiology-schedule">
      <div className="ris-radiology-subtabs">
        <button
          className={view === 'today' ? 'active' : ''}
          onClick={() => {setView('today'); handleSchedule('today');}}
        >
          Today
        </button>
        <button
          className={view === 'week' ? 'active' : ''}
          onClick={() => {setView('week'); handleSchedule('week');}}
        >
          Week
        </button>
        <button
          className={view === 'month' ? 'active' : ''}
          onClick={() => {setView('month'); handleSchedule('month');}}
        >
          Month
        </button>
      </div>
      <h3 className="ris-section-title">Schedule for {view.charAt(0).toUpperCase() + view.slice(1)}:</h3>
      {currentSchedule.length > 0 ? (
        <ul>
          {currentSchedule.map((appt) => (
                <li key={appt.id} onClick={() => {onSelectExam(appt.id); setCurrentPatient({ris_patients_id: appt.ris_patients_id, first_name: appt.first_name, last_name: appt.last_name})}} className='ris-radiology-schedule-item'>
                {appt.first_name} {appt.last_name} - {appt.exam_ordered + " |"} {formatAppointmentDate(appt.appointment_start) + " from " + formatAppointmentTimeRange(appt.appointment_start, appt.appointment_end)}
                </li>
          ))}
        </ul>
      ) : (
        <p>No appointments scheduled for this period.</p>
      )}
      <div>
        <h3>Department Summary for {view.charAt(0).toUpperCase() + view.slice(1)}</h3>
        <table className='ris-radiology-grid2'>
                <th>Patient Name</th>
                <th>Schedule Time</th>
                <th>Current or New Patient</th>
                <th>Location</th>
                <th>Prior Images</th>
                <th>Modality</th>
                <th>Description</th>
                <th>Labs Needed</th>
                <th>Facility</th>
                </table>
        {/* {!currentSchedule.length == 0 ? (
                <p>No appointments scheduled for this period.</p>
            ) : ( */}
                {Object.values(currentSchedule).map((appt) => (
                <div key={appt.id} className='ris-radiology-grid2'>
                    <td>{appt.first_name} {appt.last_name}</td>
                    <td>
                      {formatAppointmentDate(appt.appointment_start)} {" "}
                      {formatAppointmentTimeRange(appt.appointment_start, appt.appointment_end)}
                    </td>
                    <td>{appt.isNewPatient ? 'New' : 'Current'}</td>
                    <td>{appt.location || 'N/A'}</td>
                    <td>{appt.hasPriorImages ? 'Yes' : 'No'}</td>
                    <td>{appt.modality}</td>
                    <td>{appt.exam_ordered}</td>
                    <td>{appt.labsNeeded ? 'Yes' : 'No'}</td>
                    <td>{appt.facility || 'Health Hub'}</td>
                </div>
                ))}
      
      </div>
    </div>
  );
};

const ExamStatus = ({ onSelectExam }) => {
  const [examStatus, setExamStatus] = useState([]);
  const { currentPatient, setCurrentPatient } = useContext(GlobalStateContext);
  const BASE_URL = process.env.REACT_APP_API_URL;
  const {currentUser} = useContext(GlobalStateContext);
  const user = getUserId(currentUser);


  useEffect (() => {
    const fetchExamStatus = async () => {
      try {
            const response = await fetch(`${BASE_URL}/orders/radExamStatus?user=${user}&type=${currentUser.type}`);
            if (response.ok) {
            const data = await response.json();
            setExamStatus(data);
            }
        } catch (error) {
            logger.error("Error fetching radiology orders", error);
        }
    }

    fetchExamStatus();
  }, [])
  return (
    <div className="ris-radiology-exam-status">
      <h3 className="ris-section-title">Active Exams</h3>
      <table className="ris-radiology-table">
        <thead>
          <tr>
            <th>Patient</th>
            <th>Scheduled Time</th>
            <th>Modality</th>
            <th>Description</th>
            <th>Status</th>
          </tr>
        </thead>
        <tbody>

          {examStatus.map((exam) => (
            <tr key={exam.id} onClick={() => {onSelectExam(exam.id); setCurrentPatient({ris_patients_id: exam.ris_patients_id, first_name: exam.first_name, last_name: exam.last_name});}}>
              <td>{exam.first_name + " "+ exam.last_name}</td>
              <td>{exam.appointment_start ? formatAppointmentDate(exam.appointment_start) + ' ' + formatAppointmentTimeRange(exam.appointment_start, exam.appointment_end) : 'N/A'}</td>
              <td>{exam.modality}</td>
              <td>{exam.exam_ordered}</td>
              <td>{exam.status.charAt(0).toUpperCase() + exam.status.slice(1)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};


//This displays the details of the exam selected from the schedule
const ExamDetail = ({ examId, onBack }) => {
  const [subTab, setSubTab] = useState('information');
  // const exam = examDetailsData[examId] || {};
  // const [exam, setExam] = useState([]);
  const [examDetails, setExamDetails] = useState([]);
  const [examSummaries, setExamSummaries] = useState([]);
  const { currentPatient } = useContext(GlobalStateContext);
  const { currentUser } = useContext(GlobalStateContext);
  const user = getUserId(currentUser);
  const navigate = useNavigate();
  const [priority, setPriority] = useState(examDetails.priority || 'routine');
  const [status, setStatus] = useState(examDetails.status || 'scheduled');
  const [performedDate, setPerformedDate] = useState('');
  // const [numberOfImages, setNumberOfImages] = useState(examDetails.numberOfImages || 0);
  const [ptest, setpTest] = useState(false);
  const [ctest, setcTest] = useState(false);
  const [gfrTest, setgfrTest] = useState(false);
  const [fbTest, setfbTest] = useState(false);
  const [standingOrders, setStandingOrders] = useState([]);
  const BASE_URL = process.env.REACT_APP_API_URL;



  const handlePriorityChange = (e) => {
    const newPriority = e.target.value;
    setPriority(newPriority);
    // logger.log(`Priority for exam ${examId} updated to ${newPriority}`);
    // TODO: Update backend API
  };

  const handleStatusChange = (e) => {
    const newStatus = e.target.value;
    setStatus(newStatus);
    // logger.log(`Status for exam ${examId} updated to ${newStatus}`);
    // TODO: Update backend API
  };

  // const handleImagesChange = (e) => {
  //   const newImages = parseInt(e.target.value, 10) || 0;
  //   setNumberOfImages(newImages);
  //   logger.log(`Number of images for exam ${examId} updated to ${newImages}`);
  //   // TODO: Update backend API
  // };

  const fetchStandingOrdersDetails = async () => {
    try {
      const so_response = await fetch(`${BASE_URL}/orders/standingOrders?main_order_id=${examId}&user=${user}&type=${currentUser.type}`)
      if (so_response.ok) {
        const data = await so_response.json();
        if (data.length) {
          setStandingOrders(data);
        }
        if (data[0].p_id) {
          setpTest(data[0].p_id);
        } else {
          setpTest(false);
        }
        if (data[0].gfr_id) {
          setgfrTest(data[0].gfr_id);
        } else {
          setgfrTest(false);
        }
        if (data[0].fb_id) {
          setfbTest(data[0].fb_id);
        } else {
          setfbTest(false);
        }
      } else {
        logger.log("No standing order for patient")
      }
    } catch (error) {
      logger.error('Error fetching standing orders data: ', error)
    }
  };

  const fetchExamDetails = async () => {
    // logger.log('exam id: ', examId)
    try {
      const response = await fetch(
        `${BASE_URL}/orders/radExamDetails?id=${examId}&user=${user}&type=${currentUser.type}`
      );
      if (response.ok) {
        const data = await response.json();
        setExamDetails(data[0]);
        setPriority(data[0].priority)
        setStatus(data[0].status)
        setPerformedDate(data[0].performed_date ? sanitizeDateForInput(data[0].performed_date) : '');
      }
    } catch (error) {
      logger.error('Error fetching Radiology orders:', error);
    }
  };

  useEffect(() => {
    logger.log('useEffect triggered with examId:', examId, 'currentPatient:', currentPatient);

    if (!currentPatient?.ris_patients_id) return;

    // Skip fetch if examId is not defined
    if (!examId) {
      logger.warn('examId is undefined, skipping fetch');
      setExamDetails(null);
      return;
    }
    
    fetchStandingOrdersDetails();  
    fetchExamDetails();
  }, [])

  const fetchExamSummaries = async () => {
    try {
        const response = await fetch(
          `${BASE_URL}/orders/radPatientSummary?id=${currentPatient.ris_patients_id}&user=${user}&type=${currentUser.type}`
        );
        if (response.ok) {
          const data = await response.json();
          setExamSummaries(data);
        }
      } catch (error) {
        logger.error('Error fetching Radiology orders:', error);
      }
  }
  
  const savePatchData = async () => {
    try {
        const response = await fetch(`${BASE_URL}/orders/radExamDetails`, 
          { // Ensure this endpoint exists in your backend  
            method: 'PATCH',
            headers: {
          'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                priority, status, performed_date: performedDate || null, rad_orders_id: examId, user, type: currentUser.type })
            });

        if (!response.ok) {
            throw new Error(`Failed to update exam details: ${response.statusText}`);
        }

        logger.log('Radiology exam details updated successfully');
    } catch (error) {
        logger.error('Error updating exam details ', error);
        throw error;
    }
};

const returnToWorklist = async () => {
  if (!window.confirm('Return this order to the worklist? This will unlink it from its scheduled appointment.')) return;
  try {
    const response = await fetch(`${BASE_URL}/orders/returnToWorklist`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ order_id: examId, order_type: 'radiology', user, type: currentUser.type }),
    });
    if (!response.ok) throw new Error('Failed to return order to worklist');
    navigate('/orderworklist');
  } catch (error) {
    logger.error('Error returning order to worklist:', error);
  }
};

const handleStandingOrders = async () => {
  if (ptest === true){
    await handlePregnancyTest();
  }
  if (ctest === true){
    await handleCreatineTest();
  }
  if (gfrTest === true){
    await handleGFRTest();
  }
  if(fbTest === true){
    await handleForeignBody();
  }
}
  
    // logger.log(JSON.stringify(currentPatient))

const handleForeignBody =  async () => {
     const modality = "X-Ray";
     const selectedRegion = "Foreign Body";
     const examOrdered = "X-Ray Foreign Body";
     const selectedBodyPart = "Extremities";
     const cptCode = "76010";
      try {
        const response = await fetch(`${BASE_URL}/orders/radStandingOrder`, {
          method: 'POST',
          headers: {
              'Content-Type': 'application/json',
          },
          body: JSON.stringify({modality, selectedRegion, selectedBodyPart, cptCode, examOrdered, ris_patients_id: currentPatient.ris_patients_id, first_name: currentPatient.first_name, last_name: currentPatient.last_name, clinicians_id: currentUser.clinicians_id, ordering_clinician: currentUser.first_name  + ' ' + currentUser.last_name, radiology_orders_id: examId, appointment_id: examDetails.appointment_id, schedule_id: examDetails.schedule_id, user, type: currentUser.type}),
        });
        const data = await response.json();
        logger.log(data)
        if (response.ok) {
          logger.log("Added order successfully: ")
          setfbTest(data.data.radiology_order_id);
          window.alert("Successfully added standing order")
        }
      } catch (error) {
        logger.error("Error adding patient notes", error);
        }
  }
const handlePregnancyTest =  async () => {
     const sample_type = "Urine";
     const examOrdered = "Urine Pregnancy Test";
     const cptCode = "80310";
    // logger.log(JSON.stringify(currentPatient.patients_id))
      try {
        const response = await fetch(`${BASE_URL}/orders/labStandingOrder`, {
          method: 'POST',
          headers: {
              'Content-Type': 'application/json',
          },
          body: JSON.stringify({sample_type, cptCode, examOrdered, ris_patients_id: currentPatient.ris_patients_id,
            first_name: currentPatient.first_name, last_name: currentPatient.last_name,
            clinicians_id: currentUser.clinicians_id,
            ordering_clinician: currentUser.first_name  + ' ' + currentUser.last_name,
            rad_orders_id: examId, appointment_id: examDetails.appointment_id, schedule_id: examDetails.schedule_id, user,
            type: currentUser.type}),
        });
        const data = await response.json();
        logger.log(data)
        if (response.ok) {
          logger.log("Added order successfully: ")
          setpTest(data.data.lab_order_id);
          window.alert("Successfully added standing order")
        }
      } catch (error) {
        logger.error("Error adding patient notes", error);
        }
  }
const handleGFRTest =  async () => {
     const sample_type = "Blood";
     const examOrdered = "Glomerular Filtration Rate (GFR)";
     const cptCode = "82565";
    // logger.log(JSON.stringify(currentPatient.patients_id))
      try {
        const response = await fetch(`${BASE_URL}/orders/labStandingOrder`, {
          method: 'POST',
          headers: {
              'Content-Type': 'application/json',
          },
          body: JSON.stringify({sample_type, cptCode, examOrdered, ris_patients_id: currentPatient.ris_patients_id, first_name: currentPatient.first_name, last_name: currentPatient.last_name, clinicians_id: currentUser.clinicians_id, ordering_clinician: currentUser.first_name  + ' ' + currentUser.last_name, rad_orders_id: examId, appointment_id: examDetails.appointment_id, schedule_id: examDetails.schedule_id, user, type: currentUser.type}),
        });
        const data = await response.json();
        logger.log(data)
        if (response.ok) {
          logger.log("Added order successfully: ")
          setgfrTest(data.data.lab_order_id);
          window.alert("Successfully added standing order")
        }
      } catch (error) {
        logger.error("Error adding patient notes", error);
        }
  }
const handleCreatineTest =  async () => {
     const sample_type = "Blood";
     const examOrdered = "Creatine kinase (cardia enzyme) level";
     const cptCode = "82553";
    // logger.log(JSON.stringify(currentPatient.patients_id))
      try {
        const response = await fetch(`${BASE_URL}/orders/labStandingOrder`, {
          method: 'POST',
          headers: {
              'Content-Type': 'application/json',
          },
          body: JSON.stringify({sample_type, cptCode, examOrdered, ris_patients_id: currentPatient.ris_patients_id, first_name: currentPatient.first_name, last_name: currentPatient.last_name, clinicians_id: currentUser.clinicians_id, ordering_clinician: currentUser.first_name  + ' ' + currentUser.last_name, rad_orders_id: examId, appointment_id: examDetails.appointment_id, schedule_id: examDetails.schedule_id, user, type: currentUser.type}),
        });
        const data = await response.json();
        logger.log(data)
        if (response.ok) {
          logger.log("Added order successfully: ")
          setcTest(data.data.lab_order_id);
          window.alert("Successfully added standing order")
        }
      } catch (error) {
        logger.error("Error adding patient notes", error);
        }
  }
  const handleDisplayStandingOrders = async () => {
    
    try {
        const response = await fetch(`${BASE_URL}/orders/standingOrders`, {
          method: 'POST',
          headers: {
              'Content-Type': 'application/json',
          },
          body: JSON.stringify({main_order_id: examId, user, type: currentUser.type}),
        });
        if (response.ok) {
          const data = await response.json();
          logger.log("Added standing order successfully: ")
          setStandingOrders(data);
          // setHistoryNotes(data);
        }
        fetchStandingOrdersDetails()
      } catch (error) {
        logger.error("Error adding standing order", error);
        }

  }

// const getChangedFields = (newData, originalData) => {
//   const changed = {};
//   for (const key in newData) {
//     if (newData[key] !== originalData[key]) {
//       changed[key] = newData[key];
//     }
//   }
//   return changed;
// };
  

  return (
    <div className="ris-radiology-exam-detail">
      <button onClick={onBack} className='ris-radiology-back-button'>Back to List</button>
      <div className="ris-radiology-subtabs">
        <button
          className={subTab === 'information' ? 'active' : ''}
          onClick={() => setSubTab('information')}
        >
          Exam Information
        </button>
        <button
          className={subTab === 'reports' ? 'active' : ''}
          onClick={() => setSubTab('reports')}
        >
          Prior Reports
        </button>
        <button
          className={subTab === 'images' ? 'active' : ''}
          onClick={() => setSubTab('images')}
        >
          Prior Images
        </button>
        <button
          className={subTab === 'checklist' ? 'active' : ''}
          onClick={() => setSubTab('checklist')}
        >
          Patient Checklist
        </button>
        <button
          className={subTab === 'summary' ? 'active' : ''}
          onClick={() => {setSubTab('summary'); fetchExamSummaries();}}
        >
          Patient Summary
        </button>
        <Link to="/results" ><button
          className={subTab}
          onClick={() => setSubTab('results')}
        >
          Results
        </button></Link>
      </div>
      <div>
        <UserDetails/> 
        <div className="ris-radiology-form-group">
            <label>Patient DOB:</label>
            <span>{examDetails.dob || 'N/A'}</span>
          </div>
      </div>
      {subTab === 'information' && (
        <div className="ris-radiology-exam-info">
          <h3>Exam Detail</h3>
          <div className="ris-radiology-form-group">
            <label>Order ID:</label>
            <span>{examDetails.id || 'N/A'}</span>
          </div>
          <div className="ris-radiology-form-group">
            <label>Modality:</label>
            <span>{examDetails.modality || 'N/A'}</span>
          </div>
          <div className="ris-radiology-form-group">
            <label>Region:</label>
            <span>{examDetails.region || 'N/A'}</span>
          </div>
          <div className="ris-radiology-form-group">
            <label>Body Part:</label>
            <span>{examDetails.body_part || 'N/A'}</span>
          </div>
          <div className="ris-radiology-form-group">
            <label>CPT Code:</label>
            <span>{examDetails.cpt_code || 'N/A'}</span>
          </div>
          <div className="ris-radiology-form-group">
            <label>Exam Ordered:</label>
            <span>{examDetails.exam_ordered || 'N/A'}</span>
          </div>
          <div className="ris-radiology-form-group">
            <label>Clinical History:</label>
            <span>{examDetails.clinical_history || 'N/A'}</span>
          </div>
          <div className="ris-radiology-form-group">
            <label>Notes:</label>
            <span>{examDetails.notes || 'N/A'}</span>
          </div>
          <div className="ris-radiology-form-group">
            <label>Additional Options:</label>
            <span>{numberedList(examDetails.additional_options) || 'N/A'}</span>
          </div>
{/*           
          <div className="ris-radiology-form-group">
            <label>Number of Images:</label>
            <span>{exam.numberOfImages || '0'}</span>
          </div> */}
          <div className="ris-radiology-form-group">
            <label>Status:</label>
            <select value={status} onChange={handleStatusChange}>
              {statuses.map((s) => (
                <option key={s} value={s}>
                  {s.charAt(0).toUpperCase() + s.slice(1)}
                </option>
              ))}
            </select>
          </div>
          <div className="ris-radiology-form-group">
            <label>Priority:</label>
            <select value={priority} onChange={handlePriorityChange}>
              {priorities.map((p) => (
                <option key={p} value={p}>{p}</option>
              ))}
            </select>
          </div>
          <div className="ris-radiology-form-group">
            <label>Date of Service:</label>
            <input
              type="date"
              value={performedDate}
              onChange={(e) => setPerformedDate(e.target.value)}
            />
          </div>
          <div className='ris-standing-orders-container'>
            <h4>Standing Orders:</h4>
            {standingOrders.length ? (<div className='ris-standing-orders-box'>
            <p>Pregnancy Test <input type="checkbox" checked={ptest} onChange={(e) => setpTest(e.target.checked)}/></p>
            <p>Creatine <input type="checkbox" checked={ctest} onChange={(e) => setcTest(e.target.checked)}/></p>
            <p>Glomerular Filtration Rate (GFR)<input type="checkbox" checked={gfrTest} onChange={(e) => setgfrTest(e.target.checked)}/></p>
            <p>Foreign Body (X-Ray)<input type="checkbox" checked={fbTest} onChange={(e) => setfbTest(e.target.checked)}/></p>
            </div>) : (
              <button className='ris-little-blue-button' onClick={() => handleDisplayStandingOrders()}>Add Standing Order</button>
            )}
          </div>
           
          
          <div className="ris-detail-actions">
            <button className='ris-bigger-blue-button' onClick={async () => { await savePatchData(); await handleStandingOrders(); }}>Save</button>
            <button
              className="ris-worklist-button"
              onClick={returnToWorklist}
            >
              Return to Worklist
            </button>
          </div>
        </div>
      )}
      {subTab === 'reports' && <PriorReports patientId={currentPatient.ris_patients_id} />}
      {subTab === 'images' && <PriorImages patientId={currentPatient.ris_patients_id} />}
      {subTab === 'checklist' && <RadPatientChecklist id={examDetails.id} />}
      {subTab === 'summary' && (
      
        <div>
        <h3>Patient Summary</h3>
        <div className='ris-radiology-grid3'>
          <h4>Study Date</h4>
          <h4>Modality</h4>
          <h4>Region</h4>
          <h4>Body Part</h4>
          <h4>Exam Description</h4>
          <h4>Status</h4>
          <h4>Priority</h4>
          {/* <h4>Number of Images</h4> */}
          <h4>Billable History</h4>
          <h4>Prior Reports</h4>
          {/* <h4>Prior Exams</h4> */}
          <h4>Facility</h4>
        </div>
        {/* needs to display the one patients id, not all of the ids */}
        {/* {Object.values(examDetailsData).map((exam) => ( */}
        {examSummaries.map((examDetails, index) => (
          <div className='ris-radiology-grid3' key={index}>
            <p>{formatAppointmentDate(examDetails.appointment_start) + ' ' + formatAppointmentTimeRange(examDetails.appointment_start, examDetails.appointment_end) || 'N/A'}</p>
            <p>{examDetails.modality}</p>
            <p>{examDetails.region}</p>
            <p>{examDetails.body_part}</p>
            <p>{examDetails.exam_ordered}</p>
            <p>{capitalize(examDetails.status)}</p>
            <p>{capitalize(examDetails.priority)}</p>
            {/* <p>{examDetails.numberOfImages}</p> */}
            <p>{examDetails.clinical_history || 'N/A'}</p>
            <p>{examDetails.priorReports || 'No'}</p>
            {/* <p>{examDetails.priorExams || 'N/A'}</p> */}
            <p>{examDetails.facility || 'Health Hub'}</p>
            
          </div>
          ))}
        {/* ))} */}
      </div>
      )}
      </div>
    );
  };


const PriorReports = ({ patientId }) => {
  const [reports, setReports] = useState([]);
  const BASE_URL = process.env.REACT_APP_API_URL;
  const {currentUser} = useContext(GlobalStateContext);
  const user = getUserId(currentUser);


useEffect(() => {
    // logger.log('useEffect triggered with patientId:', patientId);

    // Skip fetch if examId is not defined
    if (!patientId) {
      logger.warn('patientId is undefined, skipping fetch');
      setReports(null);
      return;
    }

    const fetchReports = async () => {
      try {
        const response = await fetch(
          `${BASE_URL}/orders/radReports?id=${patientId}&user=${user}&type=${currentUser.type}`
        );
        if (response.ok) {
          const data = await response.json();
          setReports(data);
        }
      } catch (error) {
        logger.error('Error fetching Radiology orders:', error);
      }
    };
    fetchReports();
  }, [patientId])

  return (
    <div className="ris-radiology-prior-reports">
      <h3>Prior Reports</h3>
      {!reports?.length ? (
        <p>No prior reports available.</p>
        ) : (
        <>
        <div className='ris-radiology-grid'>
            <h4>Scheduled Date</h4>
            <h4>Modality</h4>
            <h4>Region</h4>
            <h4>Body Part</h4>
            <h4>Description</h4>
            <h4>Status</h4>
        </div>
        {reports.map((report) => (
            <div key={report.id} className='ris-radiology-grid'>
                <p>{report.appointment_start ? formatAppointmentDate(report.appointment_start) : 'N/A'}</p>
                <p>{report.modality ? report.modality : "N/A"}</p>
                <p>{report.region ? report.region : "N/A"}</p>
                <p>{report.body_part ? report.body_part : "N/A"}</p>
                <p>{report.exam_ordered ? report.exam_ordered : "N/A"}</p>
                <p>{report.status}</p>
                </div>
            ))}
          </>
        )}
      </div>
    );
};

    

const PriorImages = ({ patientId }) => {
  const [studies, setStudies] = useState([]);
  const [selectedStudies, setSelectedStudies] = useState([]);
  const BASE_URL = process.env.REACT_APP_API_URL;
  const {currentUser} = useContext(GlobalStateContext);
  const user = getUserId(currentUser);


  const handleSelect = (studyId) => {
    setSelectedStudies((prev) =>
      prev.includes(studyId) ? prev.filter((id) => id !== studyId) : [...prev, studyId]
    );
  };

  const handleSendToPACS = () => {
    // logger.log('Sending studies to PACS (EXA):', selectedStudies);
    // TODO: Implement POST /pacs/send API call
    // alert('Selected studies sent to PACS.');
  };

  useEffect(() => {
    // logger.log('useEffect triggered with patientId:', patientId);

    // Skip fetch if examId is not defined
    if (!patientId) {
      logger.warn('patientId is undefined, skipping fetch');
      setStudies(null);
      return;
    }

    const fetchStudies = async () => {
      try {
        const response = await fetch(
          `${BASE_URL}/orders/radImages?id=${patientId}&user=${user}&type=${currentUser.type}`
        );
        if (response.ok) {
          const data = await response.json();
          setStudies(data);
        }
      } catch (error) {
        logger.error('Error fetching Radiology orders:', error);
      }
    };
    fetchStudies();
  }, [patientId])

  return (
    <div className="ris-radiology-prior-images">
      <h3>Prior Images</h3>
      {studies?.length > 0 ? (
        <>
          <ul>
            {studies.map((study) => (
              <li key={study.id}>
                <input
                  type="checkbox"
                  checked={selectedStudies.includes(study.id)}
                  onChange={() => handleSelect(study.id)}
                />
                {study.appointment_start ? formatAppointmentDate(study.appointment_start) : "No Date"} - {study.modality} - {study.region ? study.region : "N/A"} - {study.exam_ordered}  (Prior)
              </li>
            ))}
          </ul>
          {/* <button
            onClick={handleSendToPACS}
            disabled={selectedStudies.length === 0}
            className="ris-radiology-back-button"
          >
            Send Selected to PACS
          </button> */}
        </>
      ) : (
        <p>No prior images available.</p>
      )}
    </div>
  );
};

export default Radiology;